module.exports = __webpack_public_path__ + "img/MZ-1440.c4e418f7.jpg";